import { IFrameSettings as IFrameSettingsComponent } from "../components/job-iframe/IFrameSettings";

const IFrameSettings = () => {
  return <IFrameSettingsComponent />;
};

export default IFrameSettings;
